const html = document.documentElement
// eslint-disable-next-line prefer-destructuring
const body = document.body

export { html, body }
